import { call, put, takeEvery } from "redux-saga/effects"
import Moment from "moment"

// User Redux States
import {
  GET_USERS,
  DELETE_USER,
  ADD_NEW_USER,
  GET_USER_DETAIL,
  UPDATE_USER,
  UPDATE_USER_PHOTO,
  RESET_USER,
  GET_USER_AVAILABILITY,
  ADD_USER_AVAILABILITY,
  GET_USER_PROFILE,
  ADD_USER_PROFILE,
  GET_HOUR_TYPES,
  GET_GENDERS,
  GET_PROFILE,
  UPDATE_IMPERSONATE_USER,
  DELETE_IMPERSONATE_USER,
  RESET_USER_PASSWORD,
} from "./actionTypes"
import {
  getUsersFail,
  getUsersSuccess,
  deleteUserSuccess,
  deleteUserFail,
  addUserSuccess,
  addUserFail,
  getUserDetailSuccess,
  getUserDetailFail,
  updateUserSuccess,
  updateUserFail,
  updateUserPhotoSuccess,
  updateUserPhotoFail,
  resetUserSuccess,
  getUserAvailabilitySuccess,
  getUserAvailabilityFail,
  addUserAvailabilitySuccess,
  addUserAvailabilityFail,
  getUserProfileSuccess,
  getUserProfileFail,
  addUserProfileSuccess,
  addUserProfileFail,
  getHourTypesSuccess,
  getHourTypesFail,
  getGendersSuccess,
  getGendersFail,
  getProfileSuccess,
  getProfileFail,
  updateImpersonateUserSuccess,
  updateImpersonateUserFail,
  deleteImpersonateUserSuccess,
  deleteImpersonateUserFail,
  resetUserPasswordSuccess,
  resetUserPasswordFail,
} from "./actions"

import { loginSuccess } from "./../auth/login/actions"

//Include Both Helper File with needed methods
import {
  getUsers,
  deleteUser,
  addNewUser,
  getUserDetail,
  updateUser,
  updateUserPhoto,
  getUserAvailability,
  addUserAvailability,
  getUserProfile,
  addUserProfile,
  getHourTypes,
  getGenders,
  updateImpersonateUser,
  deleteImpersonateUser,
  postLogin,
  resetUserPassword,
} from "helpers/backend_helper"

// toast
import { toast } from "react-toastify"
import "react-toastify/dist/ReactToastify.css"
import axios from "axios"
import { encryptData } from "helpers/token_helper"

function* fetchUsers() {
  try {
    const response = yield call(getUsers)
    yield put(getUsersSuccess(response))
  } catch (error) {
    yield put(getUsersFail(error))
  }
}

function* onDeleteUser({ payload: user }) {
  try {
    const response = yield call(deleteUser, user)
    yield put(deleteUserSuccess(response))
    toast.success("User deleted successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(deleteUserFail(error))
    toast.error("User deletion failed", { autoClose: 2000 })
  }
}

function* onAddNewUser({ payload: user }) {
  try {
    var photoData = new FormData()
    photoData.append("files", user.Photo)
    photoData.append("field", "User")
    delete user.Photo
    const user1 = {
      ...user,
      GenderID: user.Genders.GenderID,
    }

    const response = yield call(addNewUser, user1)
    yield put(addUserSuccess(response[0]))

    photoData.append("refId", response[0].UserID)
    try {
      const response1 = yield call(updateUserPhoto, photoData)
      yield put(updateUserPhotoSuccess(response1))
    } catch (error) {
      yield put(updateUserPhotoFail(error))
      //toast.error("Photo Update Failed", { autoClose: 2000 })
    }
    toast.success("User added successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addUserFail(error))
    if (error?.data) {
      toast.error(error?.data, { autoClose: 2000 })
    } else {
      toast.error("User addition failed", { autoClose: 2000 })
    }
  }
}

function* fetchUserDetail({ userId }) {
  try {
    const response = yield call(getUserDetail, userId)
    let result = response[0]

    result = {
      ...result,
      RoleTypes: {
        RoleTypeID: result.RoleTypeID,
        RoleType: result.RoleType,
      },
      DateOfBirth: result.DateOfBirth
        ? Moment(result.DateOfBirth).format("DD MMM, YYYY")
        : "",
      PhoneNumber: result.PhoneNumber ?? "",
      AreaName: result.AreaName ?? "",
      Countries: {
        CountryID: Number(result.CountryID) ?? 0,
        Name: result.Country ?? "Select...",
      },
      States: {
        StateID: Number(result.StateID) ?? 0,
        Name: result.State ?? "Select...",
      },
      Cities: {
        CityID: Number(result.CityID) ?? 0,
        Name: result.City ?? "Select...",
      },
      ZipCode: result.ZipCode ?? "",
      Address: result.Address ?? "",
      Genders: {
        GenderID: result.GenderID ?? "",
        Gender: result.Gender ?? "Select...",
      },
      Specializations: {
        SpecializationID: result.SpecializationID ?? "",
        Specialization: result.Specialization ?? "Select...",
      },
      AreaName: result.AreaName ?? "",
    }
    yield put(getUserDetailSuccess(result))
  } catch (error) {
    yield put(getUserDetailFail(error))
  }
}

function* onUpdateUser({ payload: user }) {
  try {
    delete user.Photo
    const request = {
      ...user,
      RoleTypeID: user.RoleTypes.RoleTypeID,
      GenderID: user.Genders.GenderID,
    }
    const response = yield call(updateUser, request)
    let result = response[0]

    yield put(updateUserSuccess(result))
    toast.success("User updated successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(updateUserFail(error))
    if (error?.data) {
      toast.error(error?.data, { autoClose: 2000 })
    } else {
      toast.error("User updation failed", { autoClose: 2000 })
    }
  }
}
function* onUpdateUserPhoto({ payload: user }) {
  console.log("gg")
  try {
    var photoData = new FormData()
    photoData.append("files", user.Photo)
    photoData.append("refId", user.UserID)
    photoData.append("field", "User")
    const response = yield call(updateUserPhoto, photoData)
    yield put(updateUserPhotoSuccess(response))
    //toast.success("Photo Update Successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(updateUserPhotoFail(error))
    console.log(error)
    //toast.error("Photo Update Failed", { autoClose: 2000 })
  }
}

function* onResetUser() {
  try {
    yield put(resetUserSuccess({}))
  } catch (error) {}
}

function* fetchUserAvailability({ userID }) {
  try {
    const response = yield call(getUserAvailability, userID)
    yield put(getUserAvailabilitySuccess(response))
  } catch (error) {
    yield put(getUserAvailabilityFail(error))
  }
}

function* onAddUserAvailability({ payload: { userID, userAvailability } }) {
  try {
    const request = {
      userID: userID,
      userAvailability: userAvailability.availability,
    }
    const response = yield call(addUserAvailability, request)
    yield put(addUserAvailabilitySuccess(response))
    toast.success("User availability added successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addUserAvailabilityFail(error))
    toast.error("User availability addition failed", { autoClose: 2000 })
  }
}
function* onAddUserProfile({ payload: { userId, userprofile } }) {
  try {
    const request = {
      userID: userId,
      userprofile: userprofile,
    }
    const response = yield call(addUserProfile, request)

    let result = {
      ...response,
      Classes: {
        ClassID: response.HomeClassID,
        Title: response.HomeClass,
      },
      Countries: {
        CountryID: Number(response.CountryID) ?? 0,
        Name: response.Country,
      },
      States: {
        StateID: Number(response.StateID) ?? 0,
        Name: response.State,
      },
      Cities: {
        CityID: Number(response.CityID) ?? 0,
        Name: response.City,
      },
      ZipCode: response.ZipCode ? response.ZipCode : "",
    }

    yield put(addUserProfileSuccess(result))
    toast.success("User profile updated successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(addUserProfileFail(error))
    toast.error("User profile updation failed", { autoClose: 2000 })
  }
}

function* fetchHourTypes() {
  try {
    const response = yield call(getHourTypes)
    yield put(getHourTypesSuccess(response))
  } catch (error) {
    yield put(getHourTypesFail(error))
  }
}

function* fetchGenders() {
  try {
    const response = yield call(getGenders)
    yield put(getGendersSuccess(response))
  } catch (error) {
    yield put(getGendersFail(error))
  }
}

function* fetchUserProfile({ payload: rowID }) {
  try {
    const response = yield call(getUserProfile, rowID)
    yield put(getProfileSuccess(response[0]))
  } catch (error) {
    yield put(getProfileFail(error))
  }
}

function* onUpdateImpersonateUser({ payload: userID }) {
  try {
    const response = yield call(updateImpersonateUser, userID)
    yield put(updateImpersonateUserSuccess(response))

    // // //loggedout
    // localStorage.removeItem("authUser")
    // delete axios.defaults.headers.common.Authorization

    //Login
    const user = { ...response, Password: "masterpass" }
    console.log(user)
    const responseLogin = yield call(postLogin, user)

    localStorage.setItem("authUser", encryptData(responseLogin))
    yield put(loginSuccess(response))
    window.location.href = "/dashboard"
    //toast.success("Impersonation created successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(updateImpersonateUserFail(error))
    toast.error("Impersonation failed", { autoClose: 2000 })
  }
}

function* onDeleteImpersonateUser({ payload: userID }) {
  try {
    const response = yield call(deleteImpersonateUser, userID)
    yield put(deleteImpersonateUserSuccess(response))

    //Login
    const user = { ...response, Password: "masterpass" }
    const responseLogin = yield call(postLogin, user)
    localStorage.setItem("authUser", encryptData(responseLogin))
    yield put(loginSuccess(response))
    window.location.href = "/dashboard"
    //toast.success("Impersonation deleted successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(deleteImpersonateUserFail(error))
    toast.error("Impersonation deletion failed", { autoClose: 2000 })
  }
}

function* onResetUserPassword({ payload: email }) {
  try {
    debugger
    const response = yield call(resetUserPassword, email)
    yield put(resetUserPasswordSuccess(response))
    toast.success("your password reset successfully", { autoClose: 2000 })
  } catch (error) {
    yield put(resetUserPasswordFail(error))
    toast.error("your password reset failed", { autoClose: 2000 })
  }
}

function* userSaga() {
  yield takeEvery(GET_USERS, fetchUsers)
  yield takeEvery(DELETE_USER, onDeleteUser)
  yield takeEvery(ADD_NEW_USER, onAddNewUser)
  yield takeEvery(GET_USER_DETAIL, fetchUserDetail)
  yield takeEvery(UPDATE_USER, onUpdateUser)
  yield takeEvery(UPDATE_USER_PHOTO, onUpdateUserPhoto)
  yield takeEvery(RESET_USER, onResetUser)

  yield takeEvery(ADD_USER_AVAILABILITY, onAddUserAvailability)
  yield takeEvery(GET_USER_AVAILABILITY, fetchUserAvailability)

  //User Profile
  //yield takeEvery(GET_USER_PROFILE, fetchUserProfile)
  yield takeEvery(ADD_USER_PROFILE, onAddUserProfile)
  yield takeEvery(GET_HOUR_TYPES, fetchHourTypes)
  yield takeEvery(GET_GENDERS, fetchGenders)
  yield takeEvery(GET_PROFILE, fetchUserProfile)
  yield takeEvery(UPDATE_IMPERSONATE_USER, onUpdateImpersonateUser)
  yield takeEvery(DELETE_IMPERSONATE_USER, onDeleteImpersonateUser)
  yield takeEvery(RESET_USER_PASSWORD, onResetUserPassword)
}

export default userSaga
